<template>
  <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.data)">
    <span>{{ statusString(params.data) }}</span>
  </vs-chip>
</template>

<script>
export default {
  name: "CellRendererStatus",
  computed: {
    chipColor() {
      return value => {
        if (value.status) {
          return "success"
        } else {
          return "danger"
        }
      }
    },
    statusString() {
      return value => {
        if (value.status) {
          return "Online"
        } else {
          return "Offline"
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
